// an offset which will be subtracted from the scroll position
const SCROLL_OFFSET = 20;

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Handle scrolling after visitng a link with an anchor
   */
  const url = window.location.href;
  if (url.indexOf("#") > -1) {
    // get the id of the element from the url
    const hash = url.split("#")[1];
    // try to find the element with that id
    const element = document.getElementById(hash);
    if (element) {
      // if the element exists, scroll to it
      setTimeout(() => {
        scrollToElement(element);
      }, 100);
    }
  }

  /**
   * Handle scrolling after clicking a link with an anchor
   */
  document.querySelectorAll('a[href*="#"]').forEach(anchor => {
    // add an event listener to the anchor link
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      // get the id of the element from the href attribute
      const target = e.target as HTMLElement;
      const link = target.closest("a[href*='#']") as HTMLLinkElement;
      const href = link.getAttribute('href');

      // if the href is empty bail out
      if (!href) return;


      // check if the link targets to a different page. So we can
      // skip scrolling to the element
      const linkWithoutHash = href.split('#')[0];
      if (!isSamePage(linkWithoutHash)) {
        window.location.href = link.getAttribute('href') || '';
        return;
      }

      const targetId = href.split('#')[1];
      if (targetId) {
        // try to find the element with that id
        const targetElement = document.querySelector(`#${targetId}`);
        if (targetElement) {
          scrollToElement(targetElement as HTMLElement);
        }
      } else {
        console.log("not found")
      }
    });
  });
});

/**
 * Scroll to the given element
 * @param element
 */
const scrollToElement = (element: HTMLElement) => {
  // get
  const headerHeight = document.querySelector('header.header')?.clientHeight || 0;
  const elementPosition = element.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({
    top: elementPosition - headerHeight - SCROLL_OFFSET,
    behavior: 'smooth'
  });
}

/**
 * Check if the given url is the same as the current page
 * @param url
 */
const isSamePage = (url: string) => {
  const currentUrl = window.location.href.replace(window.location.origin, "").split('#')[0];
  const urlWithoutHash = url.replace(window.location.origin, "").split('#')[0];

  return urlWithoutHash === currentUrl;
}
